export default "__VITE_ASSET__DFxj0wV0__"